import { useEffect, useRef, useState } from "react";

export function useHeadsObserver() {
  const [activeId, setActiveId] = useState("h1");
  const observer = useRef(null);

  useEffect(() => {
    const handleObserver = (entries) => {
      const visibleSections = entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => b.intersectionRatio - a.intersectionRatio);

      if (visibleSections.length > 0) {
        setActiveId(visibleSections[0].target.id);
      }
    };

    const headings = document.querySelectorAll("h2[id]");

    observer.current = new IntersectionObserver(handleObserver, {
      root: null,
      rootMargin: "-50% 0px -50% 0px", // trigger when element is in center
      threshold: 0,
    });

    headings.forEach((heading) => observer.current.observe(heading));
 const storedActiveId = localStorage.getItem("activeId");
    if (storedActiveId) {
      setActiveId(storedActiveId);
    }
    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
       localStorage.removeItem("activeId");
    };
  }, []);

  return { activeId, setActiveId };
}
